// extracted by mini-css-extract-plugin
export default {"language_switcher":"LanguageSwitcher_language_switcher__X39jx","formControl":"LanguageSwitcher_formControl__xydJh"};